import type {
  GroupEdgeSettings,
  PathLookupEdgeSettings,
  TopologyEdgeSettings,
} from '@ipfabric/utils';
import {
  type EdgeLabel,
  type EnabledLabels,
  getProtocolLabels,
} from './getProtocolLabels';

export const getGroupLabels = (group: GroupEdgeSettings): EnabledLabels => {
  const allLabels = group.children.reduce(
    (
      acc: EdgeLabel[],
      protocol: TopologyEdgeSettings | PathLookupEdgeSettings,
    ): EdgeLabel[] => {
      const protocolLabels = Object.keys({
        ...getProtocolLabels(protocol).center,
        ...getProtocolLabels(protocol).linecap,
      }) as EdgeLabel[];
      acc.push(...protocolLabels);
      return acc;
    },
    [],
  );
  const groupLabels = allLabels.filter((label) => {
    return group.children.every((protocol) => {
      const protocolLabels = Object.keys({
        ...getProtocolLabels(protocol).center,
        ...getProtocolLabels(protocol).linecap,
      }) as EdgeLabel[];
      return protocolLabels.includes(label);
    });
  });
  const enabledLabels = groupLabels.reduce(
    (acc: EnabledLabels, label: EdgeLabel): EnabledLabels => {
      const labelValue = group.children.every((protocol) =>
        protocol.labels.includes(label),
      );
      acc[label] = labelValue;
      return acc;
    },
    {},
  );

  return enabledLabels;
};
